import { HistoryState, useRouter, useRouterState } from "@tanstack/react-router"
import { useEffect, useState } from "react"
import { useDebounce } from '@/hooks/useDebounce'

type ObjectType = 'PLAIN' | 'OBJECT'

//when using this hook, the data must be fetched using queryClient.ensureQueryData (or similar)
//to ensure that the data is in the cache to avoid a loop of fetching and updating the history state
export function useHistoryState<T>(
    objKey: string,
    obj: T,
    objType?: ObjectType
): [T, Function] {
    const router = useRouter()
    const routerState = useRouterState()

    const [tempObj, setTempObj] = useState<T>(obj)

    const storeStateInHistory = useDebounce(() => {
        delete routerState.location.state[objKey]
        const state = {
            ...routerState.location.state,
            [objKey]: objType === 'PLAIN' ? tempObj : { ...tempObj }
        }
        router.navigate({
            to: routerState.location.pathname,
            replace: true,
            state: state as HistoryState,
        })
    }, 300)

    useEffect(() => {
        storeStateInHistory()
    }, [tempObj])

    // Load state from history when remounting the component (going back from ingredient page)
    useEffect(() => {
        const state = routerState.location.state as any

        if (state[objKey]) {
            setTempObj(objType === 'PLAIN' ? state[objKey] : {
                ...state[objKey]
            })
        } else {
            setTempObj(obj)
        }
    }, [obj])

    return [tempObj, setTempObj]
}
